/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { errorArchivedConfig } from '../../config/error.config';
export interface IErrorArchivedPluginMethods extends IPluginMethodMap {
  getErrorArchivedSync(args?: any): any;
}

export class ErrorArchivedPlugin implements IAgentPlugin {
  readonly methods: IErrorArchivedPluginMethods;

  constructor() {
    this.methods = {
      getErrorArchivedSync: this.getErrorArchivedSync.bind(this),
    };
  }

  getErrorArchivedSync(args?: any) {
    return {
      error: errorArchivedConfig,
    };
  }
}
